import React, { useEffect, useState } from 'react';

// External Components
import RangeSlider from 'react-range-slider-input';

// Styles
import { StyledAPTCSliderContainer } from './plansummary.styled';

// Common Components
import { CurrencyInput } from '../../../components/common/form';
import { ConditionalRendering } from '../../../components/common/conditional-rendering';

// Constants
import { INPUT_TYPES } from '../../../constants/inputs/inputTypes';

// Hooks
import { useAptcContext } from './hooks/useAptcContext';
import { REGEX } from '../../../constants/common/regex';

const MAX_INTEGER_LENGTH = 10;
const MAX_DECIMAL_LENGTH = '2';
const MAX_SLIDER_VALUE = 100;

const APTCSlider = ({ maxAptc = MAX_SLIDER_VALUE }) => {
    const { newAptc, setNewAptc } = useAptcContext();
    const [aptcInput, setAptcInput] = useState(`${newAptc}`);
    const [key, setKey] = useState(Math.random());

    useEffect(() => {
        if (aptcInput !== `${newAptc}`) {
            setNewAptc(Number(aptcInput));
        }
    }, [aptcInput]);

    const handleInputChange = e => {
        const value = e.target.value;

        if (value === '' || REGEX.TWO_DECIMAL_INPUT_VALUE.test(value)) {
            setAptcInput(value);
        } else {
            setKey(Math.random());
        }
    };

    return (
        <StyledAPTCSliderContainer as="div">
            <CurrencyInput
                key={key}
                // @ts-ignore
                label={{
                    wrapperClasses: ['currency-input'],
                    labelClasses: [''],
                    labelText: '',
                    showRequired: false,
                    isInputRequired: false,
                }}
                input={{
                    id: 'electedAptc',
                    isInputRequired: true,
                    type: INPUT_TYPES.TEXT,
                    value: aptcInput,
                    dataTestId: 'electedAptc',
                    name: 'electedAptc',
                    placeholder: '',
                }}
                actions={{
                    handleChange: value => handleInputChange(value),
                }}
                maskOptions={{
                    allowDecimal: true,
                    prefix: '',
                    decimalLimit: MAX_DECIMAL_LENGTH,
                    integerLimit: MAX_INTEGER_LENGTH,
                    includeThousandsSeparator: false,
                    allowLeadingZeroes: true,
                }}
                showIcon={true}
            />

            <div style={{ flex: 1 }}>
                <RangeSlider
                    id="aptc-slider"
                    rangeSlideDisabled={true}
                    defaultValue={[0, Number(aptcInput)]}
                    value={[0, Number(aptcInput)]}
                    thumbsDisabled={[true, false]}
                    max={maxAptc}
                    step={0.01}
                    onInput={e => setAptcInput(e[1].toFixed(2))}
                />
            </div>
            <p className="val" id="aptc-credit" data-testid="aptc-credit">
                <ConditionalRendering isTrue={maxAptc - newAptc >= 0}>
                    {new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(maxAptc - newAptc)}
                </ConditionalRendering>
            </p>
        </StyledAPTCSliderContainer>
    );
};

export default APTCSlider;
